export default __webpack_public_path__ + "static/media/ic-online-mock-exam-lessons.7c2fbb0e.svg";